import { InfoIcon } from '@/assets/icons/info-icons/info';
import { BannerDivider, Description, IconWrapper, StatusBannerWrapper, StatusWrapper } from '@/components/basicComponents/banner';
import Input from '@/components/basicComponents/input';
import Textarea from '@/components/basicComponents/textarea';
import { updateWizardSteps, WizardProgressBar } from '@/components/basicComponents/wizard/progressBar';
import FooterModal from '@/components/settings-page/importData/footer';
import { useResponsive } from '@/hooks/use-responsive';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTheme } from 'styled-components';
import { ManagerSpotlightWizardStepWrapper } from '..';

export interface IMessageStepForm {
  subject: string;
  messageToInvestor: string;
}

interface MessageStepProps {
  managerSpotlightWizardSteps: { name: string; status: string }[];
  messageInfo: IMessageStepForm;
  saveMessageInfo: ({ subject, messageToInvestor }: IMessageStepForm) => void;
  handleManagerSpotlightWizardSteps: (steps: { name: string; status: string }[]) => void;
}

export const MessageStep = ({ managerSpotlightWizardSteps, messageInfo, saveMessageInfo, handleManagerSpotlightWizardSteps }: MessageStepProps) => {
  const theme = useTheme();
  const { isMobile } = useResponsive();
  const {
    control,
    reset,
    handleSubmit,
    formState: { isValid }
  } = useForm<IMessageStepForm>({ mode: 'onChange' });

  useEffect(() => {
    reset(messageInfo);
  }, [messageInfo]);

  const prevStep = () => {
    updateWizardSteps('prev', managerSpotlightWizardSteps, handleManagerSpotlightWizardSteps);
  };

  const saveAndContinue = (data: IMessageStepForm) => {
    saveMessageInfo(data);
    updateWizardSteps('next', managerSpotlightWizardSteps, handleManagerSpotlightWizardSteps);
  };

  return (
    <>
      <ManagerSpotlightWizardStepWrapper isMobile={isMobile}>
        <WizardProgressBar steps={managerSpotlightWizardSteps} />
        <StatusBannerWrapper bgColor={theme.layer[12]} withBorderRadius>
          <IconWrapper>
            <InfoIcon width={26} height={26} fill={theme.font.base} />
          </IconWrapper>
          <BannerDivider dividerColor={theme.font.disabled} />
          <StatusWrapper>
            <Description color={theme.font.base}>Customize the message to introduce the selected strategies</Description>
          </StatusWrapper>
        </StatusBannerWrapper>
        <Controller
          name="subject"
          control={control}
          rules={{
            required: {
              value: true,
              message: 'This field is required'
            }
          }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              label="Subject"
              value={value || ''}
              onChange={(e) => {
                onChange(e.target.value);
              }}
              errorText={error?.message}
              isRequiredField
            />
          )}
        />
        <Controller
          name="messageToInvestor"
          control={control}
          rules={{
            required: {
              value: true,
              message: 'This field is required'
            }
          }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Textarea label="Message to Investor" value={value} onChange={onChange} errorText={error?.message} size="lg" isRequiredField />
          )}
        />
      </ManagerSpotlightWizardStepWrapper>
      <FooterModal
        startOver={prevStep}
        startOverButtonName="Back"
        confirmButton={{
          name: 'Save And Continue',
          onClick: handleSubmit(saveAndContinue),
          disabled: !isValid
        }}
      />
    </>
  );
};
